<section class="flex flex-col gap-4">
  <header class="flex items-center gap-4">
    <h3 class="text-lg font-semibold">{{ literalService.get('clients.info.configurations', true) }}</h3>
    <a class="outlinedButton ml-auto rounded-[30px] px-3 py-1.5 inline-flex gap-1 justify-center items-center cursor-pointer" (click)="startCreation()">
      <img [src]="images.plus" alt="" class="w-5 h-5" />
      <span class="font-semibold text-sm text-primary-purple">{{ literalService.get('clients.info.newConfiguration', true) }}</span>
    </a>
  </header>

  @if (groups.isLoading()) {
    <span class="loading loading-spinner loading-md text-primary-purple self-center"></span>
  } @else {
    <div class="flex flex-col">
      <a class="configuration-row selectable-row border rounded px-5 py-3 mb-2 flex items-center gap-3 cursor-pointer no-underline" [class.selected-row]="editingDefault()" (click)="selectDefault()">
        <span class="font-semibold">{{ literalService.get('clients.info.defaultConfiguration', true) }}</span>
        <span class="ml-auto text-sm text-neutrals-grey-04">
          {{ literalService.get(defaultGroup() ? 'clients.info.defaultDescription' : 'clients.info.notConfigured', true) }}
        </span>
      </a>
      @for (item of townGroupItems(); track item.group.id) {
        <a class="configuration-row selectable-row border rounded px-5 py-3 mb-2 flex items-center gap-3 cursor-pointer no-underline" [class.selected-row]="item.group.id === selectedTownGroup()?.id" (click)="selectGroup(item.group)">
          <img [src]="images.area" alt="" class="w-5 h-5 filter-primary-purple-light" />
          <span class="truncate">{{ item.townNames }}</span>
          <span class="ml-auto text-sm text-neutrals-grey-04 whitespace-nowrap">{{ item.group.towns.length }} {{ literalService.get('clients.info.areas', true) }}</span>
        </a>
      }
      @if (creating()) {
        <div class="configuration-row selectable-row selected-row border rounded px-5 py-3 mb-2 font-semibold">{{ literalService.get('clients.info.newConfiguration', true) }}</div>
      }
    </div>

    <section class="flex flex-col gap-4 pt-4 border-t border-neutrals-grey-02">
      <header class="flex items-center gap-4">
        <h3 class="text-lg font-semibold text-primary-purple truncate">{{ formTitle() }}</h3>
        @if (selectedTownGroup() && !edit()) {
          <div class="flex items-center justify-center content-image cursor-pointer ml-auto" [tooltip]="literalService.get('integrations.delete', true)" [position]="TooltipPosition.BELOW" (click)="showDeleteConfigurationModal()">
            <img [src]="images.trash" alt="" class="h-5 w-5" />
          </div>
        }
      </header>
      @if (editingDefault()) {
        <p class="text-sm text-neutrals-grey-04">{{ literalService.get('clients.info.defaultHelp', true) }}</p>
      }
      <app-client-info-form
        [clientInfo]="selectedInfo()"
        [townIds]="selectedTownIds()"
        [towns]="availableTowns()"
        [saving]="saving()"
        [(edit)]="edit"
        (save)="save($event)"
        (cancelled)="onCancelled()"
      />
    </section>
  }
</section>

<app-modal-confirmation
  [id]="'deleteClientInfoConfigurationModal'"
  [modal]="deleteModal.modal()!"
  [icon]="images.alert"
  [title]="'clients.info.actions.delete.title'"
  [text]="'clients.info.actions.delete.text'"
  [centerText]="true"
  [loading]="deleteModal.running()"
  [hidden]="!deleteModal.showed()"
  (action)="deleteConfigurationAction()"
/>
